import {
  toSimuladoSource,
  type ExamQuestion,
  type SimuladoSourceQuestion,
} from '../../domain/entities/question.entity';

/** O que o repositório precisa de uma fonte de questões: a API ou o mock. */
export interface ExamDatasource {
  getQuestions(questionIds: readonly string[]): Promise<ExamQuestion[]>;
}

export class ExamRepositoryImpl {
  private readonly datasource: ExamDatasource;

  constructor(datasource: ExamDatasource) {
    this.datasource = datasource;
  }

  /**
   * As questões do ensaio: busca pelos ids do mapper e devolve na ordem
   * dele, numeradas. É aqui, e não na tela, para que simulado e diagnóstico
   * leiam exatamente o mesmo conjunto.
   */
  async getSimulado(
    questionIds: readonly string[],
  ): Promise<SimuladoSourceQuestion[]> {
    const response = await this.datasource.getQuestions(questionIds);
    const { questions, missing } = toSimuladoSource(questionIds, response);

    // Para quem mantém o mapper: um id que a API não conhece some do ensaio
    // em silêncio, e a lista inteira teria de ser conferida à mão para achar.
    if (missing.length > 0) {
      console.warn(
        `[simulado] ${missing.length} ids do mapper sem questão na API: ${missing.join(', ')}`,
      );
    }

    return questions;
  }
}
